import getters from './userdivGetter';
import actions from './userdivAction';
import mutations from './userdivMutation';

const state = {
  userEtcInfo: {
    userId: '',
    divisionCode: '',
    applPurpose: '',
  },
  divisionInfo: {
    divisionCd: '',
  },
  allDivisionInfo: [],
  userDivisionInfo: {
    userId: '',
    divisionCd: '',
  },
  userDivisionList: [],
  divSelectOne: {},
  currentDivList: [],
  selectRole: '',
  divisionListWithSecurityMgmt: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/userdiv/userdivStore.js